import { handleActions } from 'redux-actions';

import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';

export const initialState = {
  errorMessage: null,
  idVerificationResult: {
    isVerified: false,
    isBirthDateMatched: false,
    isNameMatched: false,
    isTravelDocNoMatched: false,
    isGenderMatched: false,
    isExpiryDateMatched: false,
    isLicenseNumberMatched: false,
    isStateMatched: false,
    noOfAttempts: 0,
    isCardNumberMatched: false,
    verificationResultCode: '',
  },
  directorList: null,
  hasErroredFromVerifyIdPrefilled: false,
  isVerifyIdPrefilledError: false,
  shadowRegisteredAccountId: null,
  isShadowRegistered: false,
  isNewAccount: false,
  isRegistered: false,
  shadowRegisteredCaseId: null,
  pepStatus: null,
  isPotentialAMLIdentified: false,
  sfContactId: null,
};

const reducer = handleActions(
  {
    [actionTypes.UPDATE_ID_VERIFICATION_RESULT]: (state, { payload }) => ({
      ...state,
      idVerificationResult: payload,
    }),
    [actionTypes.UPDATE_ERROR_MESSAGE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload,
    }),
    [actionTypes.UPDATE_DIRECTOR_LIST]: (state, { payload }) => ({
      ...state,
      directorList: payload,
    }),
    [actionTypes.RESET_ID_VERIFICATION_RESULT]: (state) => ({
      ...state,
      idVerificationResult: initialState.idVerificationResult,
    }),
    [actionTypes.UPDATE_IS_VERIFY_ID_PREFILLED_ERROR]: (state, { payload }) => ({
      ...state,
      isVerifyIdPrefilledError: payload,
    }),
    [actionTypes.UPDATE_HAS_ERRORED_FROM_VERIFY_ID_PREFILLED]: (state, { payload }) => ({
      ...state,
      hasErroredFromVerifyIdPrefilled: payload,
    }),
    [actionTypes.UPDATE_SHADOW_REGISTERED_ACCOUNT_DETAILS]: (state, { payload }) => ({
      ...state,
      shadowRegisteredAccountId: payload.shadowRegisteredAccountId,
      isShadowRegistered: payload.isShadowRegistered,
      isNewAccount: payload.isNewAccount,
      isRegistered: payload.isRegistered,
      shadowRegisteredCaseId: payload.shadowRegisteredCaseId,
    }),
    [actionTypes.UPDATE_CONTACT_REGISTER_RESULT]: (state, { payload }) => ({
      ...state,
      pepStatus: payload.pepStatus,
      isPotentialAMLIdentified: payload.isPotentialAMLIdentified,
      sfContactId: payload.sfContactId,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX),
);

export default reducer;
